import api from "./api";

export const listCourses = async (params?: any) => {
    const { data } = await api.get('products/course/', {params: params});
    return data
}

export const detailCourse = async (courseId: any) => {
    const { data } = await api.get(`products/course/${courseId}`);
    return data
}